<template>
  <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">Export Users In Structure with Id: {{  structure_id }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4 d-flex align-center">
            <v-radio-group v-model="selectedExportType" row>
                <v-radio label="Export Self Only" value="0"></v-radio>
                <v-radio label="Export All Users" value="1"></v-radio>
            </v-radio-group>
            <v-btn color="primary" @click="exportUsersInStructure(structure_id, selectedExportType)">Export</v-btn>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'

export default {
    name: 'ExportUsersInStructure',
    props: {
        structure_id: Number,
    },
    data() {
        return {
            constants: constants,
            selectedExportType: ''
        };
    },
    methods: {
        exportUsersInStructure(structureId, selectedExportType)
        { 
            if(this.selectedExportType == '')
            {
                window.showAlert('Please select an export type', "warning");
                return;
            }
            window.showLoading();
            axios({
                        url: `${constants.baseApiUrl}StructureUser/ExportUsersInStructure?structureId=${structureId}&exportType=${selectedExportType}`,
                        method: 'Get', 
                        responseType: 'blob',
                    })
                .then((res) => {
                    var blob = new Blob([res.data], { type: "application/octetstream" });
                    const link = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.setAttribute("download", "ExportedData.xlsx");
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                })
                .catch((err) =>  window.showAlert(this.$t('res_Label_ExportUsersInStructureErrorMessage'), "warning") )
                .finally(() => window.hideLoading())
        }
    },
    mounted() {
        console.log(window.location.hostname)
    }
}
</script>